import { EVENT_RESPONSE, QUIZ_SUBMISSION_EVENT, RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, RCE_EVENT, PAGE_BLURRED_EVENT, PAGE_FOCUSED_EVENT } from './eventTypes';
export var assembleKinesisConfig = function assembleKinesisConfig(apiConfig) {
  return Object.assign({
    apiVersion: '2013-12-02'
  }, apiConfig);
};

// We don't really want to delay sending events for this queue.
export var responseStreamConfig = function responseStreamConfig(defaultStreamConfig, stream) {
  return Object.assign({}, defaultStreamConfig, {
    eventTypes: {
      RESPONSE: RESPONSE
    },
    maxPageSize: 1,
    stream: stream
  });
};
export var eventStreamConfig = function eventStreamConfig(defaultStreamConfig, stream) {
  return Object.assign({}, defaultStreamConfig, {
    eventTypes: {
      RESPONSE: EVENT_RESPONSE,
      SESSION_STARTED_OR_RESUMED_EVENT: SESSION_STARTED_OR_RESUMED_EVENT,
      QUIZ_SUBMISSION_EVENT: QUIZ_SUBMISSION_EVENT,
      RCE_EVENT: RCE_EVENT,
      PAGE_BLURRED_EVENT: PAGE_BLURRED_EVENT,
      PAGE_FOCUSED_EVENT: PAGE_FOCUSED_EVENT
    },
    stream: stream
  });
};
export var assembleStreamConfigs = function assembleStreamConfigs(config) {
  var defaultStreamConfig = Object.assign({
    maxPageSize: 25,
    // max number events sent at once
    sendRecordsTimeout: 5000 // in milliseconds
  }, config.stream_configuration);
  return [eventStreamConfig(defaultStreamConfig, config.stream_identifiers.events), responseStreamConfig(defaultStreamConfig, config.stream_identifiers.responses)];
};